<template>
  <article class="layout-section">
    <h2 class="layout-section__title">Contact Us</h2>
    <p>
      Dolores ipsam nemo mollitia lobortis class hac eros. Gravida vitae ultricies maxime exercitation pretium! Illo
      fugiat, eiusmod integer doloribus molestie. Irure consequuntur quo mollis eveniet atque risus quis dolorem? Quia.
    </p>

    <DemoContactForm />
  </article>
</template>

<script>
import DemoContactForm from './DemoContactForm.vue'

export default {
  name: 'DemoContact',
  components: { DemoContactForm }
}
</script>
